// @flow

import React from "react";
import { SchemaForm, Modal, ModalBody, ModalHeader, ModalFooter, Button, Col } from "@components";
import { localize } from "redux-i18n";

import http from "@http";
import type { SpecialContactsType } from "@modules/service/reducer/special-contacts-types/types";
import uiSchema from "./ui-schema";
import { getSchema } from "@utils/schema";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: ?SpecialContactsType,
  onChange?: (data: SpecialContactsType) => void,
  onSubmit: (data: SpecialContactsType) => void,
  onCancel: Function,
}>;

export class SpecialContactTypeModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  get schema() {
    return getSchema("SpecialContactTypeDTO");
  }

  onSubmit = () => {
    this.formRef.current.submit();
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onCancel} className="d-flex justify-content-between">
          {this.props.data
            ? this.props.t("RENAME_SPECIAL_CONTACT_TYPE")
            : this.props.t("ADD_SPECIAL_CONTACT_TYPE")}
        </ModalHeader>
        <ModalBody className="d-flex justify-content-center align-items-center">
          <SchemaForm
            ref={this.formRef}
            className="w-100"
            formData={this.props.data || {}}
            schema={this.schema}
            uiSchema={uiSchema}
            onSubmit={this.props.onSubmit}
            externalSubmit
          >
            <div className="d-flex justify-content-center" />
          </SchemaForm>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" type="submit" onClick={this.onSubmit}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(SpecialContactTypeModal);
